/**
 * CORE-1579 — незнакомый адрес на вебе разбирается в главную, а не в «ничего».
 *
 * Разбор адреса React Navigation (`getStateFromPath`) отдаёт `undefined` для
 * любого пути, которого нет в `linking.config`. На первой загрузке это
 * безвредно: навигатор просто открывает начальный экран. А на «назад/вперёд»
 * браузера (popstate) библиотека передаёт этот `undefined` прямо в `resetRoot`
 * (`useLinking.js`), роутер читает `undefined.routes` — и приложение падает:
 * Sentry `TypeError: Cannot read properties of undefined (reading 'routes')` в
 * `getStateForAction`, прод 02.10.2026.
 *
 * Отдаём то же, что человек и так видит на незнакомом адресе при первой
 * загрузке, — главную. Без `path`: адрес, как и раньше, переписывается на «/».
 * Псевдонимы (`pathAliases`) этим не задеты — они читают `window.location`
 * сами, до навигатора.
 */
export const UNKNOWN_PATH_STATE = { routes: [{ name: 'Home' }] };

export function withHomeFallback<P extends (path: string, options?: any) => unknown>(parse: P): P {
  return ((path: string, options?: unknown) => parse(path, options) ?? UNKNOWN_PATH_STATE) as P;
}
